import { Typography, Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import { generationData, shiftActions, removeDealerFromShift, saveShift, sendNotification } from "store/slice/shiftsSlice";
import { STUDIOS_COLORS } from "constats";

import MissedDealerError from "./missdedDealers";
import AddMissedDealersModal from "./AddMissedDealersModal";
import ConfirmationDialog from "./ConfirmationDialog";
import { CHINES_STUDIO_ID } from "constats";
import ShiftGenerationTable from "./ShiftGenerationTable"


const ShiftGenerationEdit = () => {
    const { generation } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const shiftStore = useSelector(store => store.shift);

    const {
        dealers = [],
        missingDealers = {},
        studios: studioList = [],
        creationData,
        shifts,
        success,
        addedUserDate
    } = shiftStore?.shift || {};
    console.log("missingDealers ", missingDealers)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);
    const [shiftDate, setShiftDate] = useState("");
    const [dealerId, setDealerId] = useState("");
    const [selectedShift, setSelectedShift] = useState(null);
 
    const studios = studioList.map((studio, idx) => ({ ...studio, color: STUDIOS_COLORS[idx + 1] }));

    useEffect(() => setIsModalOpen(false), [addedUserDate]);
    useEffect(() => { dispatch(shiftActions.reset()); return () => dispatch(shiftActions.reset()); }, []);
    useEffect(() => { if (shiftStore.savedShiftConf) navigate(`/shiftGeneration/${shiftStore.savedShiftConf.id}`); }, [shiftStore.savedShiftConf]);
    useEffect(() => { dispatch(generationData(generation)); }, [generation]);

    const openAddingModal = (shift, date, id) => {
        if (shift) {
            setSelectedShift(shift);
            setIsConfirmationDialogOpen(true);
        } else {
            setIsModalOpen(true);
        }
        setShiftDate(date);
        setDealerId(id);
    };

    const handleConfirmationDialogConfirm = () => {
        setIsConfirmationDialogOpen(false);
        dispatch(removeDealerFromShift({ date: shiftDate, dealerId }));
        
    };

    const save = () => dispatch(saveShift(generation));
    const sendNotifications = () => dispatch(sendNotification(generation));
    
    return (
        <DashboardLayout>
            <Typography variant="h3">Generate Shift</Typography>

            <MissedDealerError missingDealers={missingDealers} studios={studios} />
            <ul>
                {studios.map(s => (
                    <li key={s.id}>
                        {s.name} - <span style={{ display: "inline-block", width: 20, height: 20, background: s.color }}></span>
                    </li>
                ))}
            </ul>

            {shiftStore?.success?.status && <div style={{ color: "green" }}>{shiftStore?.success.message}</div>}
            <div style={{ display: 'flex', gap: 'handleModalClose10px', marginBottom: '10px', gap: '10px' }}>
                <Button variant="contained" color="primary" onClick={save}>Save Shift</Button>
                <Button variant="contained" color="secondary" onClick={sendNotifications}>Send Notifications</Button>
            </div>
            
            <ShiftGenerationTable 
                openAddingModal={openAddingModal}
                shifts={shiftStore?.shift?.shifts}
                creationData={shiftStore?.shift?.creationData} 
                missingDealers={shiftStore?.shift?.missingDealers} 
            />

            <AddMissedDealersModal
                openAddignModal={isModalOpen}
                handleModalClose={() => setIsModalOpen(false)}
                studios={studios}
                shiftDate={shiftDate}
                dealerId={dealerId}
            />

            <ConfirmationDialog
                open={isConfirmationDialogOpen}
                onClose={() => setIsConfirmationDialogOpen(false)}
                onConfirm={handleConfirmationDialogConfirm}
                title="Remove Dealer from Shift"
                message="Are you sure you want to remove this dealer from the shift?"
            />
        </DashboardLayout>
    );
};

export default ShiftGenerationEdit;
